import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.module.js';

export default class RelatedProducts {
    constructor() {
        const relatedProductsContainer = document.querySelector('.relatedProducts.hasSlider');

        if (relatedProductsContainer) {
            this.initRelatedProducts();
        }
    }

    initRelatedProducts() {
        setTimeout(() => {
            const arrow = `
                <svg xmlns="http://www.w3.org/2000/svg" width="30.84" height="60.307" viewBox="0 0 30.84 60.307">
                    <path class="primaryFill" fill="#00457c" d="M30.845 30.153L5.858 1.16C4.656-.235 2.552-.39 1.156.812-.24 2.015-.394 4.12.808 5.512l21.236 24.64L.808 54.8c-1.2 1.394-1.047 3.5.348 4.7.63.54 1.404.807 2.175.807.94 0 1.87-.392 2.53-1.157l24.987-28.997"/>
                </svg>
            `;

            tns({
                container: '.relatedProducts__inner',
                items: 1,
                controls: true,
                nav: false,
                autoplay: false,
                autoplayButtonOutput: false,
                controlsText: [arrow, arrow],
                gutter: 0,
                responsive: {
                    600: {
                        items: 2,
                        gutter: 15
                    },
                    1030: {
                        gutter: 30,
                        items: 3
                    },
                    1630: {
                        gutter: 50
                    }
                }
            });
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/components/relatedProducts/relatedProducts.js